export const STATUS_FINISHED = 'finished';
export const STATUS_STARTED = 'started';
export const STATUS_CREATED = 'created';
export const STATUS_READY = 'ready';
export const RESULT_DATE_FORMATE = 'YYYY-MM-DD HH:mm';
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const BACKEND_TIME_FORMAT = 'HH:mm:ss';
